export enum TournamentPaidStatusEnum {
  Pending = 1,
  Paid = 2,
  Cancelled = 3,
}